// extracted by mini-css-extract-plugin
export var checkboxInputRow = "p_qz";
export var checkboxInputColumn = "p_qB";
export var inputOptionRow = "p_qq";
export var inputOptionColumn = "p_qr";